var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1524_22837)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9154 3.58301H3.58305C2.5977 3.58301 1.80046 4.3892 1.80046 5.37456L1.7915 16.1239C1.7915 17.1092 2.5977 17.9154 3.58305 17.9154H17.9154C18.9008 17.9154 19.707 17.1092 19.707 16.1239V5.37456C19.707 4.3892 18.9008 3.58301 17.9154 3.58301ZM17.9154 7.16611L10.7493 11.645L3.58305 7.16611V5.37456L10.7493 9.85343L17.9154 5.37456V7.16611Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1524_22837"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.4986,
    height: 21.4986,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.245f78cb6b850d7ed2b31e9232cc6d1a.svg";
export { ForwardRef as ReactComponent };